import axios from 'axios';
import { AppConfig } from 'AppConfig';
import LocalStore from 'utils/LocalStore';

const getHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + LocalStore.getAccessToken()
});

/**
 * Get the AI Summary preference (enabled/disabled) for the current user.
 */
export async function getAiSummaryPreference() {
  const url = `${AppConfig.FO_INITIAL_URL}/user/ai-summary-preference`;
  const response = await axios.get(url, { headers: getHeaders(), hideSpinner: true });
  return response.data;
}

/**
 * Get the AI Summary and current user's enabled/disabled preference for a report/card.
 * Returns { reportId, enabled, sections, ... }; missing or disabled summaries return empty sections.
 */
export async function getAiSummary(reportId, persona) {
  const params = persona ? { persona } : undefined;
  const url = `${AppConfig.FO_INITIAL_URL}/ai-summary/${reportId}`;
  const response = await axios.get(url, { headers: getHeaders(), params, hideSpinner: true });
  return response.data;
}

/**
 * Toggle the current user's AI Summary preference.
 * @param {boolean} enabled - Whether AI Summary should be shown
 */
export async function toggleAiSummaryPreference(enabled) {
  const url = `${AppConfig.FO_INITIAL_URL}/user/ai-summary-preference/${enabled}`;
  const response = await axios.put(url, null, { headers: getHeaders(), hideSpinner: true });
  return response.data;
}
